export enum AutoCompleteType {
  TERM = 'term',
  BOOK = 'bookInfo',
  SKILL = 'skillInfo',
  CUSTOM = 'custom',
}

export enum DiscoveryJTBD {
  ChapterReview = 'chapter-review',
  VocabularyAcrossChapter = 'vocabulary/across-chapter',
  FinalReview = 'final-review',
  Introduction = 'introduction',
  AnticipationGuide = 'anticipation-guide',
  OtherSkills = 'literary-devices',
  Lessons = 'lesson',
}

export enum LoadingStatus {
  FULL = 'full',
  MORE = 'more',
  NONE = 'none',
}

export enum SubType {
  BOOK = 'book',
  SHORT_STORY = 'short-story',
  POEM = 'poem',
  PLAY = 'play',
}

export enum TAB {
  CHAPTER_REVIEW = 'chapter-review',
  PRE_READING = 'pre-reading',
  VOCABULARY = 'vocabulary',
  OTHER_SKILLS = 'other-skills',
  FINAL_REVIEW = 'final-review',
  REVIEW = 'review',
  ACT_REVIEW = 'act-review',
  LESSONS = 'lesson',
}

export enum SubTab {
  CHAPTER_WISE = 'chapter-wise',
  ACROSS_CHAPTERS = 'across-chapters',
  ACT_WISE = 'act-wise',
  ACROSS_ACTS = 'across-acts',
  VERSE_WISE = 'verse-wise',
  ACROSS_VERSES = 'across-verses',
  INTRODUCTION = 'introduction',
  ANTICIPATION_GUIDE = 'anticipation-guide',
  QUOTES = 'quotes',
  THEMES = 'themes',
  FIGURATIVE_LANGUAGE = 'figurative-language',
  CHARACTERS = 'characters',
  CENTRAL_IDEA = 'central-idea',
  TEXTUAL_EVIDENCE = 'textual-evidence',
  SETTING = 'setting',
  PLOT = 'plot',
  POINT_OF_VIEW = 'point-of-view',
  GENRE = 'genre',
  BASIC_INFORMATION = 'basic-information',
  TEXT_STRUCTURE = 'text-structure',
  MULTIMEDIA = 'multimedia',
}

export enum LEVEL {
  DOMAIN = 'domain',
  TOPIC = 'topic',
  SUB_TOPIC = 'subtopic',
  SKILL = 'skill',
  SUB_SKILL = 'subskill',
}

export enum SkillTAB {
  ALL = 'all',
  LESSONS = 'lesson',
  // adding QUIZZES in favour of REVIEW/SKILL_PRACTICE
  QUIZZES = 'quiz',
  GUIDED_PRACTICE = 'guided-practice',
  REVIEW = 'review',
  SKILL_PRACTICE = 'skill-practice',
}

export enum SkillsErrors {
  NO_RESULT = 'no_result',
  FAILED = 'failed',
  NONE = 'none',
}
